import { render, staticRenderFns } from "./DashboardPieChart.vue?vue&type=template&id=566287b2&"
import script from "./DashboardPieChart.vue?vue&type=script&lang=js&"
export * from "./DashboardPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports